export default __webpack_public_path__ + "6ef23168c48e004e62d71a0c6234a926.svg";